<template>
    <section>
        <v-btn @click="dialog=true">Add Testimonial</v-btn>
        <v-layout row style="width: 90%;margin: auto;"> 
         <v-data-table :headers="headers" 
                       :items="Testimonials" 
                       hide-actions
                       class="elevation-1" 
                       style="width:100%;margin-top:10px;"
                       disable-initial-sort
                       :loading='loading'
                       loading-text="Loading... Please wait">
                <template v-slot:headers="props">
                    <tr>
                        <th v-for="header in props.headers" :key="header.text"> {{ header.text }}</th>
                    </tr>
                </template>
                <template v-slot:items="props">
                    <tr>
                        <td class="text-xs-center">{{ props.item.Name }}</td>
                        <td class="text-xs-center">{{ props.item.Message }}</td>
                        <td class="text-xs-center">
                            <img style="height: 115px;width: 115px;margin: 5px;" :src="props.item.Photo_URL"/>
                        </td>
                        <td class="text-xs-center">{{ new Date(props.item.Created_On).toLocaleDateString() }}</td>
                        <td class="text-xs-center">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn color="primary" icon class="btnAction" v-on="on" @click="OpenDialog(props.item)">
                                        <v-icon>edit</v-icon>
                                    </v-btn>
                                </template>
                                <span>Update</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn color="error" icon class="btnAction" v-on="on" @click="DeleteTestimonial(props.item)">
                                        <v-icon>delete</v-icon>
                                    </v-btn>
                                </template>
                                <span>Delete</span>
                            </v-tooltip>
                        </td>
                    </tr>
                </template>
            </v-data-table>
          </v-layout>
          <pagination v-model="pages" :records="records" :per-page="10" @paginate="GetDataFromDB"></pagination>
        <v-dialog v-model="dialog" persistent max-width="750px">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    <v-flex v-if="!Update_Details">Add Testimonial</v-flex>
                    <v-flex v-else>Update Testimonial</v-flex>
                    <v-btn icon @click="dialog=false">
                        <v-icon color="text--secondary">close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                        <v-flex wrap style="padding: 10px;">
                            <v-flex>
                                <v-text-field label="Name" v-model="Name"></v-text-field>
                            </v-flex>
                            <v-flex>
                                <v-text-field label="Message" v-model="Message"></v-text-field>
                            </v-flex>
                            <div style="width:400px;margin:auto;border: 1px solid #d3d3d37a;">
                                <v-flex style="width: 170px;margin: auto;margin-top: 5px;">
                                    <img style="min-height: 170px;min-width: 170px;max-height: 170px;max-width: 170px;border: 1px solid lightgrey;" id="img" :src="url"/>
                                </v-flex>
                                <v-flex style="text-align: center;">
                                    <v-btn color="primary" @click="$refs.inputUpload.click()">Upload Image</v-btn>
                                    <input v-show="false" ref="inputUpload" type="file" @change="SelectedFile" >
                                </v-flex>
                            </div>
                        </v-flex>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-flex style="text-align: right;">
                            <v-btn color="primary" v-if="!Update_Details" @click="SubmitTestimonial">Submit Testimonial</v-btn>
                            <v-btn color="primary" v-else @click="UpdateTestimonial">Update Testimonial</v-btn>
                        </v-flex>
                    </v-card-actions>
            </v-card>
        </v-dialog>
    </section>
</template>
<script>
export default {
    data(){
        return{
            headers                 : [ { text: 'Name',value: 'Name' },
                                        { text: 'Message', value:'Message'},
                                        { text: 'Photo' , value : 'Photo_URL'},
                                        { text: 'Created On' , value:'Created_On'},
                                        { text: 'Actions' } ],
            Testimonials            : [],
            pages                   : 1,
            records                 : 0,
            loading                 : false,
            url                     : null,
            Image                   : null,
            dialog                  : false,
            Name                    : '',
            Message                 : '',
            Update_Details          : false,
            Testimonial_Id          : ''
        }
    },
    methods:{
        OpenDialog(item){

            this.Update_Details      = true;
            this.Testimonial_Id = item['_id'];
            this.Name    = item['Name']
            this.Message = item['Message']
            this.url     = item['Photo_URL']
            this.dialog  = true

        },
        SelectedFile(e){
        
            this.Image = e.target.files[0]
            this.url = URL.createObjectURL(this.Image);

        },
        SubmitTestimonial(){
            
            const fd = new FormData()
            fd.append('Name',this.Name)
            fd.append('Message',this.Message)
            fd.append('Testimonial',this.Image,this.Image.name)
            this.$http.post(`${this.$store.getters.GetProductionUrl}/testimonials/createtestimonial`,fd)
                        .then(response =>{
                            
                            this.Testimonials = response["data"]['response']
                            this.records = response["data"]['Records']
                            this.ClearForm()    
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Submited Testimonial","Color":"green","Close": false });
                             
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Failed To Submit Testimonial","Color":"red","Close": false });
                        })

        },
        UpdateTestimonial(){
            
            const fd = new FormData()
            fd.append('Testimonial_Id' ,this.Testimonial_Id)
            fd.append('Name',this.Name)
            fd.append('Message',this.Message)
            this.Image ? fd.append('Testimonial',this.Image,this.Image.name) : ""
            this.$http.post(`${this.$store.getters.GetProductionUrl}/testimonials/updatetestimonial`,fd)
                        .then(response =>{

                            this.Testimonials = response["data"]['response']
                            this.records = response["data"]['Records']
                            this.ClearForm()
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Submited Testimonial","Color":"green","Close": false });
                             
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Failed To Submit Testimonial","Color":"red","Close": false });
                        })

        },
        DeleteTestimonial(item){
            if (confirm("Do you really want to delete?")) {
                this.$http.post(`${this.$store.getters.GetProductionUrl}/testimonials/deletetestimonial`,{'Testimonial_Id' : item['_id']})
                            .then(response =>{

                                this.Testimonials = response["data"]['response']
                                this.records = response["data"]['Records']
                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Deleted Testimonial","Color":"green","Close": false });
                                 
                            })
                            .catch(err =>{

                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Failed To Delete Testimonial","Color":"red","Close": false });
                            })
            }

        },
        ClearForm(){

            this.Update_Details = false
            this.dialog    = false
            this.url        = null
            this.Image      = null
            this.Name       = ''
            this.Message    = ''
            this.Testimonial_Id = ''
            this.$refs.inputUpload.value = "" 
     
        },
        GetDataFromDB(){

            this.$http.post(`${this.$store.getters.GetProductionUrl}/testimonials/gettestimonials`,{ limit:10, page : this.pages })
                        .then(response =>{
                            
                            this.Testimonials = response["data"]['response']
                            this.records = response["data"]['Records']
                            this.$eventHub.$emit("LOADING",'false')
                        })
                        .catch(err =>{
                            this.$eventHub.$emit("LOADING",'false')
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Date","Color":"red","Close": false });
                        })
        }
    },
    mounted(){

        this.GetDataFromDB();

    }
}
</script>
<style>
.VuePagination ul{
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
 }
.VuePagination li{
    border: 1px solid #887a7a0f !important;
 }
 .pagination {
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
}
.page-link {
    position: relative;
    display: block;
    padding: 0.5rem 0.75rem;
    margin-left: -1px;
    line-height: 1.25;
    color: #007bff;
    background-color: #fff;
    border: 1px solid #dee2e6;
    text-decoration: none;
}
.VuePagination__count {
    font-size: 12px;
    font-weight: bold;
    text-align: right;
    text-transform: capitalize;
}
.clsForActions{
    margin: 2px;
    padding: 2px;
    border: 1px solid #0000003d;
    border-radius: 2px;
    cursor: pointer;
}
</style>